import { computed } from 'vue'
import { MutationTypes, useStore } from '@/store'
import Stomp from 'stompjs'
import SockJS from 'sockjs-client'
import { message } from 'ant-design-vue'
import { getCookie } from '@/utils/common'
import {CooperateService} from '@/api/cooperate'
import { SpaceService } from '@/api/space'
import { useRouter } from 'vue-router'
import { debounce } from 'lodash'

let client: Stomp.Client
export default () => {
  const router = useRouter()
  const contentid = Number(router.currentRoute.value.query.code)
  const projectid = Number(router.currentRoute.value.query.project)
  const slides = computed(() => store.state.slides)
  const userid = getCookie('userid')
  const store = useStore()
  const factory = {
    "Authorization":'',
    "inveteToken":''
  }
  const onLoadUserList = debounce(function() {
    getUserList()
  }, 100, { leading:false, trailing: true })
  const onLoadTemplateList = debounce(function() {
    getUserTemplateList()
  }, 100, { leading:false, trailing: true })
  const getUserList = async () => {
    const params = {
      pptContentId: contentid,
      contentType: router.currentRoute.value.query.project ? "SPACEPPT" : "PPT",
    }
    slides.value.forEach((s:any,i:any) => {
      s.elements.forEach((e:any) => {
        e.workUser = {}
        
      })
    })
    // const newSlide = slide // 当前模板数据
    const res = await CooperateService.editList(params)
    store.commit(MutationTypes.SET_EIDT_LIST, res.data.data);
    if (res.data.data && res.data.data.length < 2) return;
    res.data.data.forEach((item:any,ind:any) => {
      slides.value.forEach((s:any,i:any) => {
        if (item.pageId === (i + 1)) {
          s.elements.forEach((e:any) => {
            if (item.itemId === e.id) {
              e.workUser = item
            }
            
          })
        }
      })
      store.commit(MutationTypes.SET_SLIDES, slides.value)
      
    })
  }
  const getUserTemplateList = async () => {
    let data = null
    
    if (router.currentRoute.value.query.project) {
      await SpaceService.teamDetail(contentid).then((res) => {
        if (res.data.state === 0) {
          message.error(res.data.msg)
          router.push('/space')
          return
        }
        
        data = res.data.data.spacePptContent
        store.commit(MutationTypes.SET_SLIDES, data.content)
        // getUserList(data.content)
      })

    }
    else {
      await SpaceService.detail(contentid).then((res) => {
        if (res.data.state === 0) {
          message.error(res.data.msg)
          router.push('/space')
          return
        }
        
        data = res.data.data.pptContent
        store.commit(MutationTypes.SET_SLIDES, data.content)
        // getUserList(data.content)
      })
    }

   
  }
  const mqConnect = (inveteToken:any,token:any) => {
    const target = 'https://ppt.101dao.com/content-websocket'
    const ws = new SockJS(target)
    client = Stomp.over(ws)
    factory.inveteToken = inveteToken
    factory.Authorization = token
    // 连接与消息接收
    client.connect(factory, () => {
      // 订阅服务端的/topic/project
      // ('Info: STOMP connection opened.')
      let _url = "/topic/content/"
      if (!projectid) {
        _url = '/topic/ppt_content/'
      }
      onLoadUserList()
      client.subscribe( _url + contentid, function(message) {
        const data = JSON.parse(message.body)
        if (data.data.save) {
          onLoadTemplateList()
        }
        onLoadUserList()
      })
    }, () => {
      // console.log('Info: STOMP connection closed.')
    })
  }
  let _url = "/message/content/"
  if (!projectid) {
    _url = '/message/ppt_content/'
  }
  const sendEditState = (i:any,p:any,token:any) => {
    // 加了/message/content/saving
    const pptContentId = contentid
    const itemId = i
    const pageId = p + 1

    client.send(_url + "editing", {}, JSON.stringify({'contentId':pptContentId,'userId': userid,'itemId': itemId,'pageId': pageId}))
  }
  const sendSaveState = (i:any,p:any,token:any) => {
    // 加了/message/content/saving
    const pptContentId = contentid
    const itemId = i
    const pageId = p + 1
    client.send(_url + "saving", {}, JSON.stringify({'contentId':pptContentId,'userId': userid,'itemId': itemId,'pageId': pageId}))
  }
  return {
    mqConnect,
    sendEditState,
    sendSaveState
  }
}

